export function validateEmailInput() {
  const validationEmailInputs = document.querySelectorAll(
    "[data-validation-for]"
  );

  for (let i = 0; i < validationEmailInputs.length; i++) {
    // elements
    const validationId = validationEmailInputs[i].dataset.validationFor;
    const validateInput = document.querySelector(
      '[data-validation-id="' + validationId + '"]'
    );
    const submitBtn = document.querySelector(
      '[data-submit-id="' + validationId + '"]'
    );

    // validation fuction
    const executeEmailValidation = function (validationInput, input) {
      const validationContainer = validationInput.parentElement;

      if (validationInput.value != input.value) {
        // invalid
        validationInput.setAttribute("isvalid", "true");
        input.setAttribute("isvalid", "true");
        validationContainer.classList.add("mb-invalid-email");
        if (submitBtn) submitBtn.setAttribute("disabled", "true");
      } else {
        // valid
        validationInput.removeAttribute("isvalid");
        input.removeAttribute("isvalid");
        validationContainer.classList.remove("mb-invalid-email");
        if (submitBtn) submitBtn.removeAttribute('disabled="true"');
      }
    };

    let validationFieldAlreadyUsed = false;

    // event handler
    if (validateInput) {
      validationEmailInputs[i].addEventListener("focusout", (event) => {
        validationFieldAlreadyUsed = true;
        executeEmailValidation(validationEmailInputs[i], validateInput);
      });

      validateInput.addEventListener("focusout", (event) => {
        if (validationFieldAlreadyUsed) {
          executeEmailValidation(validationEmailInputs[i], validateInput);
        }
      });
    }
  }
}
